import React from 'react';
import scaleSize from '../../../utils/scale-size';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(48)}
    height={scaleSize(48)}
    viewBox="0 0 48 48"
    fill="none"
  >
    <rect
      className="stroke-change"
      x="8.5"
      y="14.5"
      width="31"
      height="22"
      rx="3.5"
      stroke="#9F9F9F"
      strokeWidth="3"
    />
    <path
      className="stroke-change"
      d="M11 14.5L29.15 9.13751C31.0722 8.56958 33 10.0102 33 12.0146V14.5"
      stroke="#9F9F9F"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <rect className="fill-change" x="32" y="23" width="8" height="6" rx="2" fill="#9F9F9F" />
  </svg>
);
